/* eslint-disable no-param-reassign */
import Vue from 'vue';
import moment from 'moment';
import i18n from '../i18n.js';

const LocalePlugin = {
  install(/* vue */) {
    Vue.mixin({
      methods: {
        $isDateSet(date) {
          return !(date == null || date === '');
        },
        $formatDate(date) {
          if (!this.$isDateSet(date)) return i18n.t('date_not_defined');
          moment.locale(this.$i18n.locale);
          return moment(date).format('L LT');
        },
        $formatDateTime(date) {
          if (!this.$isDateSet(date)) return i18n.t('date_not_defined');
          moment.locale(this.$i18n.locale);
          return moment(date).format('L LT');
        },
        $formatDateNoTime(date) {
          if (!this.$isDateSet(date)) return i18n.t('date_not_defined');
          moment.locale(this.$i18n.locale);
          if (date === '1') {
            return this.$t('yes');
          } else if (date === '0') {
            return this.$t('no');
          } else {
            return moment(date).format('D.M.YYYY');
          }
        },
        $formatLocalizedDate(date) {
          if (!this.$isDateSet(date)) return i18n.t('date_not_defined');
          moment.locale(this.$i18n.locale);
          return moment(date).format('dddd, LL');
        },
        $formatTime(date) {
          if (!this.$isDateSet(date)) return i18n.t('date_not_defined');
          moment.locale(this.$i18n.locale);
          return moment(date).format('LT');
        },
        $formatLocalizedDateNoWeekDay(date) {
          if (!this.$isDateSet(date)) return undefined;
          moment.locale(this.$i18n.locale);
          return moment(date).format('LL');
        },
        $formatStartEndDate(startDate, endDate) {
          if (!this.$isDateSet(startDate) && !this.$isDateSet(endDate)) return i18n.t('date_not_defined');
          moment.locale(this.$i18n.locale);
          const firstDay = moment(startDate).format('D.M');
          const lastDay = moment(endDate).format('D.M.YYYY');
          return firstDay + ' - ' + lastDay;
        },
      },
    });
  },
};

export default LocalePlugin;
